<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">

    <div *ngIf="successMessage"
        class="mb-4 p-[18px] rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2 text-sm">
        <span class="material-symbols-outlined text-[20px]">check_circle</span>
        {{ successMessage }}
    </div>

    <div *ngIf="errorMessage"
        class="mb-4 p-[18px] rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm">
        <span class="material-symbols-outlined text-[20px]">error</span>
        {{ errorMessage }}
    </div>

    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-5">
        <div>
            <h2 class="text-[22px] font-bold text-slate-900 tracking-tight">
                News Category Management
            </h2>
            <p class="text-sm text-slate-500 mt-1">
                Manage localized news category labels used by news and events.
            </p>
        </div>

        <button (click)="addNew()"
            class="flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-3.5 py-2 rounded-md font-semibold shadow transition-all text-sm">
            <span class="material-symbols-outlined text-[20px]">add</span>
            <span>Add</span>
        </button>
    </div>

    <div class="flex border-b border-slate-200 mb-4 gap-6 overflow-x-auto">
        <button *ngFor="let lang of languages" (click)="setTab(lang.code)"
            class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2 whitespace-nowrap"
            [class.text-primary]="activeTab === lang.code"
            [class.border-primary]="activeTab === lang.code">
            <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-slate-200">
            {{ lang.name }} ({{ getLanguageCount(lang.code) }})
        </button>
    </div>

    <div class="mb-4 max-w-[420px]">
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="filterCategories(activeTab)"
            placeholder="Search news categories"
            class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
    </div>

    <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
        <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
                <thead>
                    <tr class="bg-slate-50 border-b border-slate-200">
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">ID</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Category Name</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Language</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Status</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-right">Actions</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    <tr *ngFor="let obj of pagedCategories" class="hover:bg-slate-50 transition-colors">
                        <td class="px-3.5 py-2.5 text-slate-500 font-semibold">{{ obj.newsCategoryId }}</td>
                        <td class="px-3.5 py-2.5 text-slate-700 font-medium">{{ obj.categoryName }}</td>
                        <td class="px-3.5 py-2.5 text-slate-600">
                            <span class="px-2 py-1 rounded bg-slate-100 text-slate-600 text-xs">{{ obj.languageCode }}</span>
                        </td>
                        <td class="px-3.5 py-2.5 text-slate-600">
                            <span class="px-2 py-1 rounded text-xs"
                                [ngClass]="obj.isEnabled ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-slate-600'">
                                {{ obj.isEnabled ? 'Active' : 'Inactive' }}
                            </span>
                        </td>
                        <td class="px-3.5 py-2.5 text-right">
                            <div class="flex justify-end gap-2">
                                <button class="p-1.5 text-slate-400 hover:text-primary" (click)="viewData(obj.newsCategoryId, 'Edit')">
                                    <span class="material-symbols-outlined text-[20px]">edit</span>
                                </button>
                                <button class="p-1.5 text-slate-400 hover:text-red-500" (click)="viewData(obj.newsCategoryId, 'Delete')">
                                    <span class="material-symbols-outlined text-[20px]">delete</span>
                                </button>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="pagedCategories.length === 0">
                        <td colspan="5" class="px-3.5 py-12 text-center text-sm text-slate-400">
                            No news categories found.
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="filteredCategories.length > pageSize">
                    <tr>
                        <td colspan="5">
                            <div class="flex justify-center mt-6 mb-6 gap-2">
                                <button *ngFor="let page of [].constructor(totalPages()); let i = index"
                                    (click)="changePage(i + 1)"
                                    [ngClass]="currentPage === (i + 1) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'"
                                    class="px-4 py-2 min-w-[40px] rounded hover:bg-blue-400 hover:text-white transition-colors text-sm">
                                    {{ i + 1 }}
                                </button>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</main>

<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4 py-6">
    <div class="bg-white w-full max-w-[625px] max-h-[calc(100vh-64px)] overflow-hidden rounded-xl shadow-xl flex flex-col">
        <div class="px-5 py-3.5 border-b border-slate-200 flex justify-between items-center bg-slate-50">
            <div>
                <h3 class="text-[18px] font-bold text-slate-900 flex items-center gap-2">
                    <span class="material-symbols-outlined text-[20px]">category</span>
                    News Category Details
                </h3>
                <p class="text-sm text-slate-500 mt-0.5">
                    Create or update news category names for each language.
                </p>
            </div>
            <button class="text-slate-400 hover:text-slate-600" (click)="closeModal()">
                <span class="material-symbols-outlined text-[22px]">close</span>
            </button>
        </div>

        <div class="p-5 space-y-6 bg-white shadow-sm overflow-y-auto flex-1 min-h-0">
            <div class="p-6 space-y-5">
                <div class="flex items-center gap-4">
                    <label class="w-[150px] text-sm font-semibold text-gray-700">Status</label>
                    <div class="flex items-center gap-4">
                        <label class="flex items-center gap-2 cursor-pointer">
                            <input type="radio" [(ngModel)]="isEnabled" name="isEnabled" [value]="true"
                                class="w-4 h-4 text-primary border-gray-300 focus:ring-2 focus:ring-primary" />
                            <span class="text-sm text-gray-700">Active</span>
                        </label>
                        <label class="flex items-center gap-2 cursor-pointer">
                            <input type="radio" [(ngModel)]="isEnabled" name="isEnabled" [value]="false"
                                class="w-4 h-4 text-primary border-gray-300 focus:ring-2 focus:ring-primary" />
                            <span class="text-sm text-gray-700">Inactive</span>
                        </label>
                    </div>
                </div>

                <div class="flex border-b border-gray-200 gap-6 mt-6 overflow-x-auto">
                    <button *ngFor="let lang of languages" (click)="setTabPopup(lang.languageId)"
                        class="pb-3 px-6 text-sm font-semibold border-b-2 flex items-center gap-2 transition-all whitespace-nowrap"
                        [class.text-primary]="activeTabPopup === lang.languageId"
                        [class.border-primary]="activeTabPopup === lang.languageId">
                        <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-gray-200" />
                        {{ lang.name }}
                    </button>
                </div>

                <form class="space-y-4 mt-4">
                    <div *ngIf="activeTabPopup === 1">
                        <label class="block mb-1 text-sm font-semibold text-gray-700">Category Name (Khmer)</label>
                        <input type="text" [(ngModel)]="categoryNameKh" name="categoryNameKh" maxlength="100"
                            placeholder="Enter category name in Khmer"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>

                    <div *ngIf="activeTabPopup === 2">
                        <label class="block mb-1 text-sm font-semibold text-gray-700">Category Name (English)</label>
                        <input type="text" [(ngModel)]="categoryNameEn" name="categoryNameEn" maxlength="100"
                            placeholder="Enter category name in English"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                </form>
            </div>
        </div>

        <div class="px-5 py-3.5 bg-slate-50 flex justify-end gap-3 border-t border-slate-200">
            <button (click)="save()" *ngIf="isEnableSave" class="btn-primary">
                <span class="material-symbols-outlined text-[18px]">check_circle</span>
                Create
            </button>
            <button (click)="update()" *ngIf="isEnableUpdate" class="btn-warning">
                <span class="material-symbols-outlined text-[18px]">warning</span>
                Update
            </button>
            <button (click)="delete()" *ngIf="isEnableDelete" class="btn-danger">
                <span class="material-symbols-outlined text-[18px]">delete</span>
                Delete
            </button>
        </div>
    </div>
</div>
